// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"X4-z"};